export default "__VITE_ASSET__Nh9XbhS$__"